// @flow

// Types
import type {
  ImportJobsToolOperator,
} from '../types'

// Constants
import {
  MODEL,
  BRANCH,
} from 'hfty-model-import-jobs-tool'

// Libs
import composeOperator from 'fc-operations'

// Exports
export const operator: ImportJobsToolOperator = composeOperator({
  model: MODEL,
  branch: BRANCH,
})

export default operator
